import { plugins, theme } from '@global-engineering-shared/gweb-global-theme';

export default {
  theme,
  plugins,
} as const;
